import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFileImportDetail extends Layout {
    panelFieldInfo: Panel;
    panelOptions: Panel;
    panelTableField: Panel;
    sourceFileImportDetail: DataSource;
    switchAllowUpdate: Switch;
    switchRequired: Switch;
    switchTruncateValue: Switch;
    switchUpshifted: Switch;
    switchUseDefault: Switch;
    textboxAdditionalColumns: Textbox;
    textboxColumnDelimiter: Textbox;
    textboxDateFormat: Textbox;
    textboxFieldName: Textbox;
    textboxFormat: Textbox;
    textboxHelpline: Textbox;
    textboxMappedToColumn: Textbox;
    textboxSetCellValue: Textbox;
    textboxSetEffectValue: Textbox;
    textboxTableName: Textbox;
}
